import Printer from '../../../models/impresora'

export function requestPrinters (place) {
  return dispatch => {
    dispatch({ type: 'REQUEST_PRINTERS' })
    return Printer.getPrinters(place)
      .then(printers => {
        dispatch({
          type: 'RECEIVE_PRINTERS',
          place,
          printers })
      })
      .catch(err => err)
  }
};

export function setPrinter (place, printer, printerName) {
  return dispatch => {
    dispatch({ type: 'SELECT_PRINTER', place, printer, printerName })
  }
};
